const STYLES = {
  active: "bg-midnight-black text-clean-white",
  approved: "bg-midnight-black text-clean-white",
  upcoming: "bg-stranger-orange text-clean-white",
  pending_review: "bg-amber-100 text-amber-700",
  completed: "bg-midnight-black text-clean-white",
  cancelled: "bg-soft-gray text-midnight-black/70",
  registered: "bg-stranger-orange text-clean-white",
  matched: "bg-midnight-black text-clean-white",
  waitlisted: "bg-amber-100 text-amber-700",
  suspended: "bg-soft-gray text-midnight-black/70",
  banned: "bg-red-100 text-red-700",
  rejected: "bg-red-100 text-red-700",
  deleted: "bg-red-100 text-red-700",
  pending: "bg-stranger-orange text-clean-white",
  needs_info: "bg-stranger-orange text-clean-white",
  not_submitted: "bg-soft-gray text-midnight-black/70",
};

const LABELS = {
  not_submitted: "Not Submitted",
  needs_info: "Needs Info",
  pending_review: "Pending Review",
  waitlisted: "Waitlisted",
};

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || `status-badge-${status}`}
    className={`text-[10px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-full whitespace-nowrap ${STYLES[status] || "bg-soft-gray text-midnight-black/70"}`}
  >
    {LABELS[status] || status}
  </span>
);
